export const formatINR = (n) =>
  `₹${(Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const formatINRPrecise = (n) =>
  `₹${(Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const formatCurrency = (n, code = "INR") => {
  const v = Number(n) || 0;
  if (code === "USD") return `$${v.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  return formatINR(v);
};
